import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  show(event) {
    const button = event.currentTarget
    const modal = document.getElementById('user_edit_modal')
    const form = document.getElementById('user_edit_form')

    // Populate form fields with user data (only if elements exist)
    const userIdField = document.getElementById('modal_user_id')
    const userNameField = document.getElementById('modal_user_name')
    const userEmailField = document.getElementById('modal_user_email')
    const userPhoneField = document.getElementById('modal_user_phone')
    const userCpfField = document.getElementById('modal_user_cpf')
    const userCnpjField = document.getElementById('modal_user_cnpj')
    const userRoleDisplayField = document.getElementById('modal_user_role_display')
    const userRoleLabelField = document.getElementById('modal_authenticated_role_label')
    const userAssignedRoleField = document.getElementById('modal_user_secondary_tag')
    const userAssignedRoleContainer = document.getElementById('assigned_role_container')
    const avatarElement = document.getElementById('modal_user_avatar')

    const userId = button.dataset.userId || ''
    const userRole = button.dataset.userRole || ''
    const conversationAgentName = button.dataset.conversationAgentName || 'assistente'
    const hasAssignableConversations = button.dataset.hasAssignableConversations === 'true'

    if (userIdField) userIdField.value = userId
    if (userNameField) userNameField.value = button.dataset.userName || ''
    if (userEmailField) userEmailField.value = button.dataset.userEmail || ''
    if (userPhoneField) userPhoneField.value = button.dataset.userPhone || ''
    if (userCpfField) userCpfField.value = button.dataset.userCpf || ''
    if (userCnpjField) userCnpjField.value = button.dataset.userCnpj || ''
    if (userAssignedRoleField) userAssignedRoleField.value = button.dataset.userSecondaryTag || ''

    // Show/hide assigned role field based on whether user has assignable conversations
    if (userAssignedRoleContainer) {
      if (hasAssignableConversations) {
        userAssignedRoleContainer.style.display = 'block'
      } else {
        userAssignedRoleContainer.style.display = 'none'
      }
    }

    // Handle static authenticated role display
    if (userRoleDisplayField) {
      let roleDisplay = 'Sem papel definido'
      if (userRole) {
        switch (userRole) {
          case 'owner':
            roleDisplay = 'Proprietário'
            break
          case 'tenant':
            roleDisplay = 'Inquilino'
            break
          default:
            roleDisplay = userRole
        }
      }
      userRoleDisplayField.value = roleDisplay
    }

    // Update label with conversation agent name
    if (userRoleLabelField) {
      userRoleLabelField.textContent = `Papel autenticado pela ${conversationAgentName}`
    }

    // Set form action to the correct URL with current filters
    if (form && userId) {
      const currentUrl = new URL(window.location)
      const params = new URLSearchParams(currentUrl.search)
      form.action = `/conversation_users/${userId}?${params.toString()}`
    }

    // Update avatar with user data (only if element exists)
    if (avatarElement) {
      const userName = button.dataset.userName || ''

      // Generate initials for avatar
      let initials = '?'
      if (userName) {
        if (userName.includes(' ')) {
          const parts = userName.split(' ')
          initials = `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
        } else {
          initials = userName.substring(0, 2).toUpperCase()
        }
      }

      // Find the span element inside the avatar structure and update initials
      const avatarSpan = avatarElement.querySelector('span')
      if (avatarSpan) {
        avatarSpan.textContent = initials
      }
    }

    modal.showModal()
  }

  close() {
    const modal = document.getElementById('user_edit_modal')
    modal.close()
  }
}
